import copy from '../../demo/fixtures/w5/copy.json'
import { useDemoStore } from '../../demo/store'
import { Button, GlossaryText, Modal } from '../../ui'
import { ProcessSteps } from './ProcessSteps'
import { fillTemplate, type W5Live } from './live'
import { useProcessRun } from './useProcessRun'
import styles from './AnalysisPage.module.css'

interface HandToAiDialogProps {
  open: boolean
  finding: W5Live['report']['findings'][number] | null
  onClose: () => void
  onDone: (message: string) => void
}

export function HandToAiDialog({ open, finding, onClose, onDone }: HandToAiDialogProps) {
  const handToAi = useDemoStore((state) => state.handW5FindingToAi)
  const { visibleSteps, running, run } = useProcessRun()

  const confirm = async () => {
    if (!finding) return
    const vars = {
      findingTitle: finding.title,
      evidence: `${finding.evidence?.value ?? '—'} · ${finding.evidence?.sub ?? '—'}`,
      willDo: finding.handoff.willDo,
    }
    const completed = await run(copy.process.handToAi.map((step) => ({ label: fillTemplate(step.label, vars), detail: fillTemplate(step.detail, vars) })), copy.process)
    if (!completed) return
    handToAi(finding.id)
    onDone(`已交给 AI：${finding.handoff.willDo}`)
    onClose()
  }

  return (
    <Modal open={open} title={`交给 AI 接手：${finding?.title ?? ''}`} hint={finding ? `${finding.evidence?.value ?? ''} · ${finding.evidence?.sub ?? ''}` : undefined} onClose={running ? () => undefined : onClose} footer={<><Button variant="ghost" disabled={running} onClick={onClose}>取消</Button><Button disabled={running} onClick={() => void confirm()}>{running ? '正在交接' : '确认交给 AI'}</Button></>}>
      {finding ? <div className={styles.handoffBody}>
        <p><b>AI 会做什么</b>：<GlossaryText text={finding.handoff.willDo} /></p>
        <p><b>AI 不会动什么</b>：<GlossaryText text={finding.handoff.wontDo} /></p>
      </div> : null}
      {running ? <div className={styles.processSlot}><ProcessSteps steps={visibleSteps} /></div> : null}
    </Modal>
  )
}
